import { styled } from "@mui/material";
import Split from "react-split";

export const StyledSplit = styled(Split)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",

    "& > .gutter": {
        position: "sticky",
        top: 0,
        display: "flex",
        height: "75vh",
        alignItems: "center",
        justifyContent: "center",
        cursor: "col-resize",
    },

    "& > .gutter::after": {
        content: '""',
        display: "block",
        width: 8,
        height: 100,
        opacity: 0.25,
        backgroundColor: theme.palette.core.grey._40,
        borderRadius: 4,
    },

    "& > .gutter:hover::after": {
        opacity: 1,
    },
}));
